import { SITE } from "@/data/legal";

const links = [
  { href: `${SITE}/legal/terms`, label: "Terms" },
  { href: `${SITE}/legal/privacy`, label: "Privacy" },
  { href: `${SITE}/legal/refund`, label: "Refunds" },
  { href: `${SITE}/pricing`, label: "Pricing" },
  { href: `${SITE}/contact`, label: "Contact" },
];

/** Legal links under the auth cards. Point to the canonical pages on the
 *  marketing site (editlock.io) — the app does not host legal pages. */
export function AuthLegalLinks() {
  return (
    <div className="mt-8 flex flex-wrap justify-center gap-x-4 gap-y-1.5">
      {links.map((l) => (
        <a
          key={l.href}
          href={l.href}
          target="_blank"
          rel="noopener noreferrer"
          className="text-xs text-muted-foreground transition-colors hover:text-foreground"
        >
          {l.label}
        </a>
      ))}
    </div>
  );
}
